const useStatusCalculations = () => {
    const getStatusColor = (status: number) => {
        return status >= 0.9 ? "success.main" : status >= 0.5 ? "primary.main" : status >= 0.3 ? "warning.main" : "error.main";
    }
    return { getStatusColor }
}
export default useStatusCalculations;